import { BaseService } from '../base';
import type { CidSearchResponse } from './types';

type ServiceResponse<T> = {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
};

const BASE_URL = import.meta.env.VITE_API_URL;

/**
 * Consulta de CID-10 via Public-Data API (proxy do Portal API).
 * Busca por descrição (ex.: "colera") ou código (ex.: "A00.1").
 */
export class CidsService extends BaseService {
  async search(params: {
    q: string;
    page?: number;
    pageSize?: number;
  }): Promise<ServiceResponse<CidSearchResponse>> {
    const q = (params.q ?? '').trim();
    // 1 caractere é ruído; q vazio é permitido (catálogo inicial do combo).
    if (q.length === 1) {
      return {
        success: true,
        data: {
          items: [],
          meta: {
            page: 1,
            pageSize: params.pageSize ?? 50,
            total: 0,
            totalPages: 0,
            hasNext: false,
          },
        },
      };
    }
    try {
      const qs = new URLSearchParams({
        q,
        page: String(params.page ?? 1),
        pageSize: String(params.pageSize ?? 50),
      });
      const response = await this.get(
        `/portal/v1/services/cids/search?${qs.toString()}`,
        {},
        BASE_URL
      );
      return await this.handleJsonResponse<CidSearchResponse>(response);
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Erro ao consultar CIDs',
      };
    }
  }
}

export const cidsService = new CidsService();

export type { CidItem, CidSearchMeta, CidSearchResponse } from './types';
